var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 400",
    width: 1200,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipb9b2OB44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.97 163C263.72 163 270 169.28 270 177.02C270 194.22 270 231.79 270 248.98C270 256.72 263.72 263 255.97 263C221.58 263 132.41 263 98.02 263C90.27 263 84 256.72 84 248.98C84 231.79 84 194.22 84 177.02C84 169.28 90.27 163 98.02 163C132.41 163 221.58 163 255.97 163Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipc146vYBf5M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.99 162.99C215.99 133.49 216 67.83 216 44.03C216 36.28 209.71 30 201.96 30C167.56 30 78.43 30 44.03 30C36.28 30 30 36.28 30 44.03C30 85.23 30 194.76 30 235.96C30 243.71 36.28 249.99 44.03 249.99C52.23 249.99 69.5 250 85 250",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipaVaMsnf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 140C104 145.52 99.52 150 94 150C88.48 150 84 145.52 84 140C84 134.48 88.48 130 94 130C99.52 130 104 134.48 104 140Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipa6zq7M0AxA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 140C162 145.52 157.52 150 152 150C146.48 150 142 145.52 142 140C142 134.48 146.48 130 152 130C157.52 130 162 134.48 162 140Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipfcwTXhX11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 212C125 217.52 120.52 222 115 222C109.48 222 105 217.52 105 212C105 206.48 109.48 202 115 202C120.52 202 125 206.48 125 212Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipb17SaxuuZo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 212C249 217.52 244.51 222 239 222C233.48 222 229 217.52 229 212C229 206.48 233.48 202 239 202C244.51 202 249 206.48 249 212Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipi2mt8I3kE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.01 249C67.01 258.89 67.01 265.08 67.01 267.55C67.01 268.9 65.91 270 64.56 270C61.65 270 55.36 270 52.45 270C51.1 270 50.01 268.9 50.01 267.55C50 265.08 50 258.89 50.01 249",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipa1zRZEZQU1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.5 262C124.5 264.93 124.5 266.76 124.5 267.5C124.5 268.88 123.38 270 122 270C119.1 270 112.9 270 110 270C108.62 270 107.5 268.88 107.5 267.5C107.5 266.76 107.5 264.93 107.5 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipbjTeZVsYu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 262C196 264.93 196 266.77 196 267.5C196 268.88 194.88 270 193.5 270C190.6 270 184.4 270 181.5 270C180.12 270 179 268.88 179 267.5C179 266.77 179 264.93 179 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipe6uXGn5Dcz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.5 262C246.5 264.94 246.5 266.77 246.5 267.5C246.5 268.88 245.38 270 244 270C241.1 270 234.9 270 232 270C230.62 270 229.5 268.88 229.5 267.5C229.5 266.77 229.5 264.94 229.5 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M 47.014 85.97 L 217.074 85.97 L 217.074 145.83 L 122.524 145.83 L 122.524 179.16 L 190.544 179.16 L 190.544 235.95 L 122.524 235.95 L 122.524 326.76 L 47.014 326.76 L 47.014 85.97 ZM 250.132 82.57 C 250.132 71.683 254.102 62.67 262.042 55.53 C 269.975 48.39 280.518 44.82 293.672 44.82 C 306.592 44.82 317.022 48.39 324.962 55.53 C 332.895 62.67 336.862 71.683 336.862 82.57 C 336.862 93.223 332.895 102.067 324.962 109.1 C 317.022 116.127 306.592 119.64 293.672 119.64 C 280.518 119.64 269.975 116.127 262.042 109.1 C 254.102 102.067 250.132 93.223 250.132 82.57 Z M 255.572 134.94 L 331.082 134.94 L 331.082 326.76 L 255.572 326.76 L 255.572 134.94 ZM 479.434 262.48 L 497.464 262.48 L 497.464 326.76 L 468.894 326.76 C 416.294 326.76 389.994 300.573 389.994 248.2 L 389.994 197.86 L 366.184 197.86 L 366.184 134.94 L 389.994 134.94 L 389.994 88.69 L 465.494 88.69 L 465.494 134.94 L 496.784 134.94 L 496.784 197.86 L 465.494 197.86 L 465.494 249.56 C 465.494 254.093 466.57 257.38 468.724 259.42 C 470.877 261.46 474.447 262.48 479.434 262.48 ZM 533.927 82.57 C 533.927 71.683 537.897 62.67 545.837 55.53 C 553.771 48.39 564.314 44.82 577.467 44.82 C 590.387 44.82 600.817 48.39 608.757 55.53 C 616.691 62.67 620.657 71.683 620.657 82.57 C 620.657 93.223 616.691 102.067 608.757 109.1 C 600.817 116.127 590.387 119.64 577.467 119.64 C 564.314 119.64 553.771 116.127 545.837 109.1 C 537.897 102.067 533.927 93.223 533.927 82.57 Z M 539.367 134.94 L 614.877 134.94 L 614.877 326.76 L 539.367 326.76 L 539.367 134.94 ZM 763.23 262.48 L 781.26 262.48 L 781.26 326.76 L 752.69 326.76 C 700.09 326.76 673.79 300.573 673.79 248.2 L 673.79 197.86 L 649.98 197.86 L 649.98 134.94 L 673.79 134.94 L 673.79 88.69 L 749.29 88.69 L 749.29 134.94 L 780.58 134.94 L 780.58 197.86 L 749.29 197.86 L 749.29 249.56 C 749.29 254.093 750.366 257.38 752.52 259.42 C 754.673 261.46 758.243 262.48 763.23 262.48 Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    style: {
      fill: "rgb(9, 171, 139)",
      whiteSpace: "pre"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.333333, 0, 0, 1.333333, 810, 0.00001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipb9b2OB44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.97 163C263.72 163 270 169.28 270 177.02C270 194.22 270 231.79 270 248.98C270 256.72 263.72 263 255.97 263C221.58 263 132.41 263 98.02 263C90.27 263 84 256.72 84 248.98C84 231.79 84 194.22 84 177.02C84 169.28 90.27 163 98.02 163C132.41 163 221.58 163 255.97 163Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipc146vYBf5M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.99 162.99C215.99 133.49 216 67.83 216 44.03C216 36.28 209.71 30 201.96 30C167.56 30 78.43 30 44.03 30C36.28 30 30 36.28 30 44.03C30 85.23 30 194.76 30 235.96C30 243.71 36.28 249.99 44.03 249.99C52.23 249.99 69.5 250 85 250",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115 165L115 32",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131 165L131 32",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipaVaMsnf4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 140C104 145.52 99.52 150 94 150C88.48 150 84 145.52 84 140C84 134.48 88.48 130 94 130C99.52 130 104 134.48 104 140Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipa6zq7M0AxA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 140C162 145.52 157.52 150 152 150C146.48 150 142 145.52 142 140C142 134.48 146.48 130 152 130C157.52 130 162 134.48 162 140Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269 194L85 194",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269 230L85 230",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipfcwTXhX11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 212C125 217.52 120.52 222 115 222C109.48 222 105 217.52 105 212C105 206.48 109.48 202 115 202C120.52 202 125 206.48 125 212Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipb17SaxuuZo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 212C249 217.52 244.51 222 239 222C233.48 222 229 217.52 229 212C229 206.48 233.48 202 239 202C244.51 202 249 206.48 249 212Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipi2mt8I3kE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.01 249C67.01 258.89 67.01 265.08 67.01 267.55C67.01 268.9 65.91 270 64.56 270C61.65 270 55.36 270 52.45 270C51.1 270 50.01 268.9 50.01 267.55C50 265.08 50 258.89 50.01 249",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipa1zRZEZQU1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.5 262C124.5 264.93 124.5 266.76 124.5 267.5C124.5 268.88 123.38 270 122 270C119.1 270 112.9 270 110 270C108.62 270 107.5 268.88 107.5 267.5C107.5 266.76 107.5 264.93 107.5 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipbjTeZVsYu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 262C196 264.93 196 266.77 196 267.5C196 268.88 194.88 270 193.5 270C190.6 270 184.4 270 181.5 270C180.12 270 179 268.88 179 267.5C179 266.77 179 264.93 179 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipe6uXGn5Dcz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.5 262C246.5 264.94 246.5 266.77 246.5 267.5C246.5 268.88 245.38 270 244 270C241.1 270 234.9 270 232 270C230.62 270 229.5 268.88 229.5 267.5C229.5 266.77 229.5 264.94 229.5 262",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41571a53b0db83c311ba95ad023d3155.svg";
export { ForwardRef as ReactComponent };